import React, { FC } from 'react';
import { getDatePickerFormat, getDateFnsLocale } from 'utils/format';
import { FormControl, IconButton, Box } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';

type ArrowDateFilterProps = {
    onDateFilterChange: (date: Date | null) => void;
    dateValue: Date;
    label: string;
};
const ArrowDateFilter: FC<ArrowDateFilterProps> = ({ onDateFilterChange, dateValue, label }: ArrowDateFilterProps) => {
    const onPreviousDay = () => {
        const date = moment(dateValue);
        onDateFilterChange(date.subtract(1, 'days').toDate());
    };

    const onForwardDay = () => {
        const date = moment(dateValue);
        onDateFilterChange(date.add(1, 'days').toDate());
    };

    return (
        <Box display="flex">
            <IconButton size="small" onClick={() => onPreviousDay()}>
                <ChevronLeftIcon />
            </IconButton>

            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
                <FormControl fullWidth margin="dense">
                    <DatePicker
                        format={getDatePickerFormat()}
                        value={dateValue}
                        label={label}
                        onChange={onDateFilterChange}
                    />
                </FormControl>
            </LocalizationProvider>

            <IconButton size="small" onClick={() => onForwardDay()}>
                <ChevronRightIcon />
            </IconButton>
        </Box>
    );
};

export default ArrowDateFilter;
